import { React, useRef, useState, useEffect } from 'react';
import { useAuth } from '../Components/AuthContext';
import { useNavigate } from 'react-router-dom';
import EditDeleteTable from '../Components/EditDeleteTable';
// not ever used, but leaving this code here if it might get used in the future
import AddEditHealthcareWorkerModal from '../Components/AddEditHealthcareWorkerModal';
import DeleteModal from '../Components/DeleteModal';
import styles from '../Styles/ViewOfUsersPages.module.css';

function ViewOfGMFAcounts() {
    // State for storing Global Medic Force accounts
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const url = process.env.REACT_APP_API_URL;

    const { token } = useAuth(); // Access token from AuthContext

    // Fetch Global Medic Force accounts data from API
    const fetchGMFAccounts = async () => {
        try {
            const response = await fetch(
                `${url}/gmf-employee/list?verified=true`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            setRows(data);
        } catch (error) {
            console.error('Error fetching Global Medic Force accounts:', error);
            setErrorMessage('Failed to fetch Global Medic Force accounts');
        }
    };

    // Use effect to load data on component mount
    useEffect(() => {
        fetchGMFAccounts();
    }, []);

    // Define table columns with improved widths and cell renderers
    const columns = [
        { field: 'first_name', headerName: 'First Name', width: 300, flex: 1 },
        { field: 'last_name', headerName: 'Last Name', width: 320, flex: 1 },
        { field: 'email', headerName: 'Email', width: 400, flex: 1 },
    ];

    // no one can edit other accounts
    const canEdit = () => false;
    // All users that can access this page (GMF accounts) can delete other GMF accounts
    const canDelete = () => true;

    // Handler to delete a Global Medic Force account
    const deleteGMFAccount = async (id) => {
        try {
            const response = await fetch(`${url}/gmf-employee/${id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to delete Global Medic Force account');
            }
            fetchGMFAccounts();
        } catch (error) {
            console.error('Error deleting Global Medic Force account:', error);
        }
    };

    // Handler to add/edit a Global Medic Force account
    const addEditGMFAccount = async (data, id) => {
        if (id) {
            editGMFAccount(data, id);
        } else {
            addGMFAccount(data);
        }
    };

    // not ever used, but leaving this code here if it might get used in the future
    const editGMFAccount = async (data, id) => {
        // try {
        //     const response = await fetch(`${url}/gmf-employee/${id}`, {
        //         method: 'PUT',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             Authorization: `Bearer ${token}`,
        //         },
        //         body: JSON.stringify(data),
        //     });
        //     if (!response.ok) {
        //         throw new Error('Failed to update Global Medic Force account');
        //     }
        //     fetchGMFAccounts();
        // } catch (error) {
        //     console.error('Error updating Global Medic Force account:', error);
        // }
    };

    // not ever used, but leaving this code here if it might get used in the future
    const addGMFAccount = async (data) => {
        // try {
        //     // Set default latitude/longitude values if not provided
        //     data.latitude_at_creation = data.latitude_at_creation || 0.0;
        //     data.longitude_at_creation = data.longitude_at_creation || 0.0;
        //     const response = await fetch(`${url}/gmf-employee`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             Authorization: `Bearer ${token}`,
        //         },
        //         body: JSON.stringify(data),
        //     });
        //     if (!response.ok) {
        //         throw new Error('Failed to add Global Medic Force account');
        //     }
        //     fetchGMFAccounts();
        // } catch (error) {
        //     console.error('Error adding Global Medic Force account:', error);
        // }
    };

    // Reference for the Add/Edit modal trigger
    const openAddGMFAccountModal = useRef(null);

    return (
        <div className={styles.viewOfUsersContainer}>
            <h2>Global Medic Force Accounts</h2>

            {errorMessage && <div className="alert error">{errorMessage}</div>}

            <div className={styles.tableWrapper}>
                <EditDeleteTable
                    rows={rows}
                    columns={columns}
                    // not ever used, but needs to be here since we are using EditDeleteTable
                    // also might get used in the future
                    editModal={AddEditHealthcareWorkerModal}
                    deleteModal={DeleteModal}
                    // not ever used, but needs to be here since we are using EditDeleteTable
                    // also might get used in the future
                    showEditButton={canEdit()}
                    showDeleteButton={canDelete()}
                    // Custom confirmation message in a concise format
                    customConfirmMessage={(row) =>
                        `${row?.first_name || 'Unknown'} ${
                            row?.last_name || 'Unknown'
                        }, with email ${row?.email || 'Unknown'}`
                    }
                    // not ever used, but needs to be here since we are using EditDeleteTable
                    // also might get used in the future
                    onAdd={(handler) => {
                        openAddGMFAccountModal.current = handler;
                    }}
                    // not ever used, but needs to be here since we are using EditDeleteTable
                    // also might get used in the future
                    onEdit={addEditGMFAccount}
                    onConfirmDelete={deleteGMFAccount}
                />
            </div>
        </div>
    );
}

export default ViewOfGMFAcounts;
